import { DNA } from '../visual-language'
import { makeTokenStyles } from '../utils'

export interface ToneProps {
  /**
   * [Tone](https://dna.telstrahealth.com/colour/#tones) of voice being used.
   */
  tone: keyof typeof DNA.tokens.semantic.color
}
export interface WeightProps {
  /** Font weight/density. */
  weight: keyof typeof DNA.tokens.font.weight
}
export interface LevelProps {
  /**
   * Element's level within the typographic heirarchy. Scales [font size](https://developer.mozilla.org/en-US/docs/Web/CSS/font-size) and [line height](https://developer.mozilla.org/en-US/docs/Web/CSS/line-height).
   */
  level: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
}

export const toneStyles = makeTokenStyles(DNA.tokens.semantic.color, {
  color: (_: string, val: string) => val,
})

export const weightStyles = makeTokenStyles(DNA.tokens.font.weight, {
  fontWeight: (_: string, val: string) => val,
})
